document.addEventListener("DOMContentLoaded", (event) => {
  
  var elements = document.querySelectorAll('.beae-product-single__picker-option-color ul li.beae-product-single__swatch-item');
  elements.forEach(function(element) {
      // Attach the click event handler during the capturing phase
      element.addEventListener('click', function(e) {
          e.preventDefault(); // Prevent the default action of the click event
          e.stopImmediatePropagation();
          
          // Your custom code here
          var data_value = this.getAttribute("data-value");
          var getValue = data_value.toLowerCase().replaceAll(' ','');
          console.log('getValue',getValue.trim());
          var currenUrl = window.location.pathname;
          var lastIndex = currenUrl.lastIndexOf('-');
          var firstPart = currenUrl.substring(0, lastIndex);
          var finalUrl = firstPart + "-" + getValue;
          $.getJSON(`https://laxhaclothing.com${finalUrl}.json` , function(data) {
              // Process the JSON data
              data.product.variants.forEach(function(variant) {
                console.log('variant',variant);
                if (variant.option1 == data_value) {
                  console.log('data value',data_value);
                    console.log('variant.id',variant.id);
                   var newUrl = `https://laxhaclothing.com${finalUrl}?variant=${variant.id}`;
                   window.location.href = newUrl ;
                }
              });
          })
      }, true); // Set the third parameter to true to indicate capturing phase
  });
});